import React, {useEffect, useState} from 'react';
import styles from './Notifications.module.scss';

interface NotificationProps {
    id: string;
    type: 'success' | 'error' | 'info' | 'warning';
    title: string;
    message: string;
    onClose: (id: string) => void;
    duration?: number;
}

const Notification: React.FC<NotificationProps> = ({
                                                       id,
                                                       type,
                                                       title,
                                                       message,
                                                       onClose,
                                                       duration = 5000
                                                   }) => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const showTimer = setTimeout(() => setIsVisible(true), 10);

        let closeTimer: ReturnType<typeof setTimeout>;
        if (duration > 0) {
            closeTimer = setTimeout(handleClose, duration);
        }

        return () => {
            clearTimeout(showTimer);
            closeTimer && clearTimeout(closeTimer);
        };
    }, [duration]);

    const handleClose = () => {
        setIsVisible(false);
        setTimeout(() => onClose(id), 300);
    };

    const getIcon = () => {
        const icons = {
            success: (
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                        d="M16.6667 5L7.50004 14.1667L3.33337 10"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            ),
            error: (
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                        d="M15 5L5 15M5 5L15 15"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            ),
            info: (
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <circle cx="10" cy="10" r="9" stroke="currentColor" strokeWidth="1.5"/>
                    <text x="10" y="14" textAnchor="middle" fill="currentColor" fontSize="12" fontWeight="bold">
                        i
                    </text>
                </svg>
            ),
            warning: null
        };

        return icons[type];
    };

    return (
        <div className={`${styles.notification} ${styles[type]} ${isVisible ? styles.visible : styles.hidden}`}>
            <div className={styles.notificationIcon}>{getIcon()}</div>
            <div className={styles.notificationContent}>
                <h4 className={styles.notificationTitle}>{title}</h4>
                <p className={styles.notificationMessage}>{message}</p>
            </div>
            <button
                className={styles.notificationClose}
                onClick={handleClose}
                aria-label="Закрыть уведомление"
            >
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                          strokeLinejoin="round"/>
                </svg>
            </button>
        </div>
    );
};

export default Notification;